module.exports = __webpack_public_path__ + "static/media/star_rating.7b62fd72.svg";